import { ref } from 'vue';

export const mountedElements = ref([]);

const vMounted = {
  mounted(el, name) {
    mountedElements.value.push({
      el,
      name,
    });
  },
  unmounted(el) {
    mountedElements.value = mountedElements.value.filter((e) => e.el !== el);
  },
};

export default vMounted;
